import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { client } from '../api/client'

const initialState = []

export const getFlags = createAsyncThunk('flag/flags', async () => {
  const response = await client.get(`/flags`)
  return response.data
})

export const getFlagsAll = createAsyncThunk('flag/flagsAll', async () => {
  const response = await client.get(`/flags-all`)
  return response.data
})

const flagSlice = createSlice({
  name: 'flag',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getFlags.fulfilled, (state, action) => {
      return action.payload.sort((a,b)=>b.flags-a.flags)
    })
    .addCase(getFlagsAll.fulfilled, (state, action) => {
      return action.payload
    })
  }
})

export default flagSlice.reducer